import React, { Component } from 'react';
import update from 'immutability-helper';
import * as UserActions from "../actions/UserActions";
import {connect} from 'react-redux'
import {Button, Clearfix, Form, FormControl, FormGroup} from "react-bootstrap";
import firebase from '../firebase';
import Loading from "../components/Loading";
import {LinkContainer} from "react-router-bootstrap";
import * as queryString from "query-string";

class SignInPage extends Component {

    constructor(props){
        super(props);

        let successMessage = null;

        const query = queryString.parse(this.props.location.search);
        if(query.verified === "true"){
            successMessage = "Your e-mail address has been verified. Sign in to continue."
        }

        this.state = {
            successMessage,
            message: null,
            loading: false,
            form: {
                email: "",
                password: "",
            }
        };

    }

    componentWillMount(){
        if(this.props.location.search.indexOf("session-expired") > -1){
            this.setState({message: "Your session expired.", loading: false})
        }



    }

    componentWillReceiveProps(nextProps){
        if(!!nextProps.user){
            this.props.history.push("")
        }
    }

    handleChange(event) {
        this.setState({form:
            update(this.state.form, {
                [event.target.name]: {$set: event.target.value}
            })
        });
    }

    submitForm(event){
        event.preventDefault();

        this.setState({message: null, messageLong: null, loading: true})
        firebase
            .auth()
            .signInWithEmailAndPassword(this.state.form.email, this.state.form.password)
            .catch(err => {
                if (err.code === "auth/user-disabled") {
                    this.setState({message: "Wrong sign-in credentials.", messageLong: "Please make sure to verify your e-mail address before signing in.", loading: false})
                } else {
                    this.setState({message: "Wrong sign-in credentials.", messageLong: null, loading: false})
                }
            })
    }

    render(){
        return (
            <div className="form-holder">
                <div className="card sign-in">
                    <div className="card-heading">
                        <h1 className="card-title">
                            Sign in
                            {this.state.loading ? (
                                    <Loading right loading={this.state.loading} />
                            ) : (
                                <LinkContainer to="/new-team">
                                    <Button className="pull-right">
                                        Sign up
                                    </Button>
                                </LinkContainer>
                            )}
                        </h1>
                    </div>
                    <div className="card-body">
                        <div className="success-message">{this.state.successMessage}</div>
                        <Form onSubmit={this.submitForm.bind(this)}>
                            <FormGroup>
                                <FormControl componentClass="input" placeholder="E-mail address" type="e-mail" name="email" value={this.state.form.name} onChange={this.handleChange.bind(this)} />
                            </FormGroup>
                            <FormGroup>
                                <FormControl componentClass="input" placeholder="Password" type="password" name="password" value={this.state.form.password} onChange={this.handleChange.bind(this)} />
                            </FormGroup>
                            <FormGroup>
                                <div className="error-message">{this.state.message}</div>
                                <Button className="pull-right" bsStyle="primary" type="submit">
                                    Sign in
                                </Button>
                                <div className="clearfix" />
                            </FormGroup>
                        </Form>
                        <div className="error-message-long">{this.state.messageLong}</div>
                        <Clearfix />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    users: state.users,
    user: state.users.active
}), dispatch => ({
    setActiveUser: id => dispatch(UserActions.setActiveUser(id))
}))(SignInPage);


// WEBPACK FOOTER //
// ./src/pages/SignInPage.js